/**
 * T048: Sign-Up Route
 * Route definition for sign-up page
 */

import { createFileRoute, redirect } from '@tanstack/react-router'
import { SignUpPage } from '@/pages/auth/sign-up'
import { queryKeys } from '@/lib/query-keys'
import { getMe, ApiError } from '@/services/auth'

interface AuthMeResponse {
  user: {
    id: string
    email: string
    name: string
  }
}

export const Route = createFileRoute('/sign-up')({
  beforeLoad: async ({ context }) => {
    // Check if already authenticated
    try {
      const data = await context.queryClient.fetchQuery<AuthMeResponse>({
        queryKey: queryKeys.auth.me(),
        queryFn: () => getMe(),
        staleTime: 1000 * 60, // 1 minute
        retry: false,
      })
      if (data?.user) {
        throw redirect({ to: '/prompts' })
      }
    } catch (error) {
      // Not authenticated, continue to sign-up page
      if (error instanceof ApiError && error.status === 401) {
        return
      }
      // Re-throw redirect errors
      throw error
    }
  },
  component: SignUpPage,
})
